import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import Radio from "components/v2/Radio/Radio";
import testIds from "constants/testIds";
import MultistopPodCompletionWarning from "./MultistopPodCompletionWarning";

export default function MarkShipmentDeliveredField() {
  const intl = useIntl();
  const { control, watch } = useFormContext();
  const markShipmentAsDone = watch("mark_shipment_as_done");

  const options = [
    {
      value: "false",
      label: intl.formatMessage({ id: "general.no", defaultMessage: "No" }),
    },
    {
      value: "true",
      label: intl.formatMessage({ id: "general.yes", defaultMessage: "Yes" }),
    },
  ];

  return (
    <div className="d-flex flex-column gap-sm">
      <div>
        <div className="text-sm text-secondary-v2 font-medium mb-sm">
          <FormattedMessage
            id="components.molecules.top-nav.markOverallShipmentDelivered"
            defaultMessage="Mark overall shipment as Delivered"
          />
          <span className="text-danger ml-xss">*</span>
        </div>
        <Controller
          name="mark_shipment_as_done"
          control={control}
          rules={{
            validate: (value) => typeof value === "boolean",
          }}
          render={({ field }) => (
            <Radio
              size="md"
              options={options}
              value={String(field.value)}
              onChange={(value) => field.onChange(value === "true")}
              getOptionTestId={(option) =>
                option.value === "true"
                  ? testIds.SHIPMENT_DASHBOARD_MULTISTOP_POD_MARK_DELIVERED_YES
                  : testIds.SHIPMENT_DASHBOARD_MULTISTOP_POD_MARK_DELIVERED_NO
              }
            />
          )}
        />
      </div>
      {markShipmentAsDone && <MultistopPodCompletionWarning />}
    </div>
  );
}
